import React from "react";
import _ from "lodash";
import { compose } from "recompose";
import { connect } from "react-redux";
import { MessageDescriptor } from "react-intl";

import { Api } from "@api/index";
import { connectToApi } from "@api/components/connectToApi";
import { Localisation } from "@localisation/index";
import { Locale } from "@localisation/models";
import { getLocale } from "@localisation/selectors";
import { Select, SelectProps } from "@ui/Select";
import { LocalisationState, Country } from "../../models";
import { getCountries, getCountriesArrayForSelect } from "../../selectors";

interface Props {
    options: Country[];
    value: Country[];
    locale: Locale;
}

interface OuterProps {
    selected: string | string[];
    multiple?: boolean;
    placeholder?: string;
    placeholderMessage?: MessageDescriptor;
    onChange?: (code: string | string[]) => void;
}

type SelectCountry = typeof Select<Country>;
const SelectCountry = Select as SelectCountry;

class CountrySelect extends React.Component<Props & OuterProps> {
    private handleChange(option: Country | Country[]) {
        const { onChange } = this.props;
        if (this.props.onChange != null) {
            if (Array.isArray(option)) {
                onChange(_.map(option, (country) => country.code));
            }
            else if (option != null) {
                onChange(option.code);
            }
            else {
                onChange(null);
            }
        }
    }

    public render() {
        const { options, value, multiple, placeholder, placeholderMessage, locale } = this.props;
        const props: SelectProps<Country> = {
            getOptionValue: (country) => country.code,
            getOptionLabel: (country) => Localisation.translateMap(country.printableName, locale),
            isMulti: multiple != null && multiple === true,
            options,
            value,
            onChange: this.handleChange.bind(this),
        };
        if (placeholder != null) {
            props.placeholder = placeholder;
        }
        if (placeholderMessage != null) {
            props.placeholderMessage = placeholderMessage;
        }
        return (
            <div className="country-select">
                <SelectCountry {...props}/>
            </div>
        );
    }
}

const mapStateToProps = (state: LocalisationState, { selected }: OuterProps) => {
    const countries = getCountries(state);
    let value: Country[] = [];
    if (!Array.isArray(selected)) {
        selected = [selected];
    }
    value = _.map(selected, (code) => countries.get(code));
    return {
        options: getCountriesArrayForSelect(state),
        value,
        locale: getLocale(state),
    };
};

const ConnectedCountrySelect = compose<Props, OuterProps>(
    connect(mapStateToProps, null),
    connectToApi({
        actionCreator: Api.countriesIndex,
        showRefresh: false,
    }),
)(CountrySelect);

export {
    CountrySelect as CountrySelectPresenter,
    ConnectedCountrySelect as CountrySelect,
};
